import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../common/store/useFlavorStore';

const Wrapper = styled.div(({ $background, $color }: {
  $background: string,
  $color: string
}) => `
  position: relative;
  padding: 30rem 20rem;
  flex-shrink: 0;

  background: url(${$background});

  h2 {
    color: ${$color};
    font-size: 27rem;
  }
`);

const Header = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const background = `/static/images/hero/${flavor}.png`;
  let color: string;

  switch (flavor) {
    case "elderflower":
    case "pear":
      color = "#000"
      break;
    default:
      color = "#fff";
  }

  return (
    <Wrapper
      $background={background}
      $color={color}
    >
      <h2>DMCA / Copyright Disclaimer</h2>
    </Wrapper>
  );
}

export default React.memo(Header);